module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e525",
      "role": "presentation",
      "src": "images/10_Choices_0020_001.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Choice 1: I Choose God’s Love"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "d7e165720"
    }
  }, [_c('b', [_c('i', [_vm._v("Choice 1: I Choose God’s Love")])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_02",
      "role": "doc-chapter",
      "title": "Choice 2: I Choose God’s Forgiveness"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "d9t00020"
    }
  }, [_c('b', [_c('i', [_vm._v("Choice 2: I Choose God’s Forgiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e166520"
    }
  }, [_c('em', [_vm._v("Who am I? Why am I here?")]), _vm._v(" These are the questions that have plagued the minds of thinking people throughout the ages. The second question is, in fact, a subset of the first. Everything flows from the answer to the "), _c('em', [_vm._v("who am I")]), _vm._v(" question. When you know who you are, you will understand why you are here, and what you are supposed to accomplish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e169120"
    }
  }, [_vm._v("At the center of the identity question is the issue of God Himself. If there is a God, if He made the universe and me, if He knows me and loves me and, incredibly, forgives me . . . well, that changes everything. But you have to choose that for yourself. Deep in the heart of every person is a longing for the God who made him. There is a big part of who you are that will always be restless until it finds identity in the God who loves you and made you for Himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e171720"
    }
  }, [_vm._v("What follows here is the furthest thing from a theology class or a Sunday school lesson. It’s a presentation about the reality of who you are being tied up in the God of the universe. It’s time to embrace your connection to God with your whole heart, as your identity. Choosing that reality will truly change your life forever. The first identity choice involves choosing God’s love. The second identity choice is about choosing the forgiveness we all need and that He so generously offers to each of us. But you have to choose it. Let’s get to work on these two identity choices.")]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_01",
      "role": "doc-chapter",
      "title": "Beginning Prayer"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "d7e175021"
    }
  }, [_c('b', [_vm._v("Beginning Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e175521"
    }
  }, [_c('em', [_vm._v("God, shine a searchlight upon me that I might see myself clearly and that I might find in You the love and forgiveness that my heart so desperately needs. Help me to see and embrace the identity that is available and mine in Christ through my choosing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177321"
    }
  }, [_c('em', [_vm._v("May all that You are to me become life in me, that I would draw it to myself and make it all that it can be in my life by Your grace. I ask for Your help in making these choices. Be at work in me. I invite Your presence. I welcome You.")]), _vm._v(" "), _c('em', [_vm._v("Change my life as You would want to.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e179021"
    }
  }, [_c('em', [_vm._v("In the name of Your Son, Jesus Christ. Amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e180022"
    }
  }, [_c('b', [_vm._v("For God so loved the world,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("that he gave his only Son,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("that whoever believes in him")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("should not perish but have eternal life.")])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e181622"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—JOHN 3:16 ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77373d9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MacD_ISBN9781418573447_epub_c12.5_r1.vue
// module id = 84
// module chunks = 0